export const CUSTOMER_INFO_SET_PROPERTY = 'CUSTOMER_INFO_SET_PROPERTY';
export const CUSTOMER_INFO_SET_BILLING_INFO = 'CUSTOMER_INFO_SET_BILLING_INFO';
export const CUSTOMER_INFO_ADD_SERVICE_ADDRESS = 'CUSTOMER_INFO_ADD_SERVICE_ADDRESS';
export const CUSTOMER_INFO_SET_SELECTED_SERVICE = 'CUSTOMER_INFO_SET_SELECTED_SERVICE';
export const CUSTOMER_INFO_REMOVE_SERVICE_ADDRESS = 'CUSTOMER_INFO_REMOVE_SERVICE_ADDRESS';
export const CUSTOMER_INFO_SET_SELECTED_LOCATION = 'CUSTOMER_INFO_SET_SELECTED_LOCATION';
export const CUSTOMER_INFO_SET_UPGRADABLE_SERVICE = 'CUSTOMER_INFO_SET_UPGRADABLE_SERVICE';
export const CUSTOMER_INFO_SET_CUSTOM_REQUEST = 'CUSTOMER_INFO_SET_CUSTOM_REQUEST';
export const CUSTOMER_INFO_SET_SELECTED_PLAN = 'CUSTOMER_INFO_SET_SELECTED_PLAN';